import styles from "./ViewTruck.module.scss";
import {
  CONSTANTS_DATA,
  truckColumns,
} from "../../../CreateJobView/MaterialTruckDetails/TruckDetails/constants";
import { Table } from "antd";
import ConditionalRender from "../../../../../reusable-components/ConditionalRender";
import { set } from "react-hook-form";

const ViewTruck = ({ truckDetails, handleOpenBidTool }) => {
  const data = truckDetails
    ?.filter((item) => item?.type === "truck")
    ?.map((item) => {
      return {
        deliveryLocation: item?.deliveryLocation,
        pickupLocation: item?.pickUpAddress,
        milesDuration: `${item?.duration?.text}, ${item?.milesData?.text}`,
        duration: item?.duration,
        milesData: item?.milesData,
        truckType: item?.truckType,
        materialTruckName: item?.materialName,
        truckingCost: item?.truckingCost,
        truckingPrice: item?.truckingPrice,
        dropOffLatLng: item?.dropOffLatLng,
        pickUpLatLng: item?.pickUpLatLng,
        truckingCostType: item?.truckingCostType,
        truckingPriceType: item?.truckingPriceType,
        isBlocked: item?.isBlocked,
      };
    });
  const columns = truckColumns({ handleOpenBidTool });
  return (
    <ConditionalRender
      visible={truckDetails?.length > 0}
      fallback={
        <div className={styles.TruckDetailsContainer}>
          <h1>{CONSTANTS_DATA.NO_DATA}</h1>
        </div>
      }
    >
      <Table dataSource={data} columns={columns} />
    </ConditionalRender>
  );
};
export default ViewTruck;
